import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { Lot, Customer } from './';

@Model()
export default class BookingQuote extends ApplicationRecord {
  static jsonapiType = 'booking-quotes';

  static scopeFactory() {
    return BookingQuote.includes([]);
  }

  @Attr() startDatetime: string;
  @Attr() endDatetime: string;
  @Attr() extrasCost: string;
  @Attr() discountRate: string;
  @Attr() totalCost: string;
  @Attr() parkingCost: string;
  @Attr() amountDiscounted: string;
  @Attr() subscriptionDiscount: string;
  @Attr() calculateSubscriptionGaps: boolean;

  @HasOne() lot: Lot;
  @HasOne() customer: Customer;
}
